import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';
import { Col, Row } from 'antd';

import { updateUrlStateInReducer, updateMapParams } from "../../action/morpheus.state.action"
import { getSlideAndInitialiseMapState } from './map_utils'
import { loadMorpheusSettings } from "../../action/morpheus.state.action"
import AppBoard from './appboard'

import logo from "../../asset/img/logo-mp.png"
import "../../asset/style/neoviewer/slidemap.css"
import cookie from 'react-cookies';

class SlideMap extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      slide: -1,
      isFetching: true,
      isErrored: false,
      loadedMap: false, 
      mapId: this.props.map_id
    };
    
    this.previewMapRef = null;
    this.props.dispatch(loadMorpheusSettings());
    this.props.dispatch(updateUrlStateInReducer(this.props.urlState));
    
    if (cookie.loadAll().isMobile == 'true') {
      window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      });
    }
  }

  addPreviewMapControl = (previewMapRef) => this.previewMapRef = previewMapRef;
          
  updateUrlState = () => {

    this.props.dispatch(updateMapParams(
      this.props.urlState, 
      this.state.view.getCenter()[0], 
      this.state.view.getCenter()[1], 
      this.state.view.getZoom(), 
      this.state.view.getRotation()
    ));
  };

  componentDidMount = () => {
      getSlideAndInitialiseMapState(this.props.slide_id, (obj) => {
        obj.goHome = this.goHome;
        obj.addPreviewMapControl = this.addPreviewMapControl;
        this.setState(obj)
      }, this.props.urlState, this.updateUrlState);
  }

  componentDidUpdate = () => {
    if (!this.state.loadedMap && !this.state.isFetching && !this.state.isErrored) {
      this.state.slidemap.setTarget("map-" + this.props.map_id);
      if (this.previewMapRef != undefined) {
        console.log("Preview Map Was Undefined!!!");
        this.setState({
          loadedMap: true
        })
        this.state.slidemap.addControl(this.previewMapRef);
      }
      if (this.props.urlState.x === -1 ) this.goHome();
    }
  }

  goHome = () => this.state.slidemap.getView().fit(this.state.layer.getExtent());

  render() {

    if (this.state.isErrored) {
      console.log(this.state.errMessage);
    }

    return (
      this.state.isFetching || this.state.isErrored ? <div>Loading</div> :
        <Row className="slide-map-row" > 
            <Col className="slide-map-col">
              <Row>
                  <AppBoard slideState={this.state} />
                  <Col tabIndex="0" id={"map-" + this.props.map_id} className="slide-map-container">
                    <img className="morphle-watermark" id="morphle-watermark" src={logo}></img>
                  </Col>
              </Row>
            </Col>
        </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    urlState: state.viewerUrlReducer,
  };
};

export default connect(mapStateToProps)(SlideMap);
